import { useT } from "@/lib/i18n";
import { COMPANY, GA_MEASUREMENT_ID } from "@/lib/legal";
import { Button } from "@/components/ui/button";
import { useConsent } from "@/lib/consent";
import { LegalLayout, Section } from "./Imprint";

export default function PrivacyPage() {
  const { t } = useT();
  const { openPreferences } = useConsent();

  return (
    <LegalLayout title={t("legal.privacy.title")}>
      <p className="text-slate-400">{t("legal.privacy.intro")}</p>

      <Section title={t("legal.privacy.controllerTitle")}>
        <p className="font-medium text-slate-100">{COMPANY.name}</p>
        <p>{COMPANY.street}</p>
        <p>
          {COMPANY.postalCode} {COMPANY.city}, {COMPANY.country}
        </p>
        <p>
          E-Mail:{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#D4AF37] hover:underline"
          >
            {COMPANY.email}
          </a>
        </p>
      </Section>

      <Section title={t("legal.privacy.dataTitle")}>
        <p>{t("legal.privacy.dataBody")}</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>{t("legal.privacy.data.account")}</li>
          <li>{t("legal.privacy.data.trips")}</li>
          <li>{t("legal.privacy.data.company")}</li>
          <li>{t("legal.privacy.data.tech")}</li>
        </ul>
      </Section>

      <Section title={t("legal.privacy.purposeTitle")}>
        <p>{t("legal.privacy.purposeBody")}</p>
      </Section>

      <Section title={t("legal.privacy.legalBasisTitle")}>
        <p>{t("legal.privacy.legalBasisBody")}</p>
      </Section>

      <Section title={t("legal.privacy.recipientsTitle")}>
        <p>{t("legal.privacy.recipientsBody")}</p>
      </Section>

      <Section title={t("legal.privacy.retentionTitle")}>
        <p>{t("legal.privacy.retentionBody")}</p>
      </Section>

      <Section title={t("legal.privacy.cookiesTitle")}>
        <p>{t("legal.privacy.cookiesBody")}</p>
        <div className="mt-3 rounded-md border border-[#272A35] bg-[#0C0E14]/60 p-3 space-y-2 text-xs">
          <div>
            <span className="font-semibold text-slate-100">
              {t("consent.cat.necessary.title")}
            </span>
            <p className="text-slate-400 mt-0.5">
              {t("legal.privacy.storage.necessary")}
            </p>
          </div>
          <div>
            <span className="font-semibold text-slate-100">
              {t("consent.cat.functional.title")}
            </span>
            <p className="text-slate-400 mt-0.5">
              {t("legal.privacy.storage.functional")}
            </p>
          </div>
          <div>
            <span className="font-semibold text-slate-100">
              {t("consent.cat.statistics.title")}
            </span>
            <p className="text-slate-400 mt-0.5">
              {t("legal.privacy.storage.statistics", { id: GA_MEASUREMENT_ID })}
            </p>
          </div>
        </div>
        <div className="mt-3">
          <Button
            onClick={openPreferences}
            variant="secondary"
            className="bg-[#1A1E2C] border border-[#363A49] hover:bg-[#272A35] text-slate-100"
            data-testid="privacy-open-preferences"
          >
            {t("legal.privacy.changePrefs")}
          </Button>
        </div>
      </Section>

      <Section title={t("legal.privacy.rightsTitle")}>
        <p>{t("legal.privacy.rightsBody")}</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>{t("legal.privacy.rights.access")}</li>
          <li>{t("legal.privacy.rights.rectify")}</li>
          <li>{t("legal.privacy.rights.erase")}</li>
          <li>{t("legal.privacy.rights.restrict")}</li>
          <li>{t("legal.privacy.rights.portability")}</li>
          <li>{t("legal.privacy.rights.object")}</li>
          <li>{t("legal.privacy.rights.complain")}</li>
        </ul>
        <p className="mt-2">
          {t("legal.privacy.rightsContact")}{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-[#D4AF37] hover:underline"
          >
            {COMPANY.email}
          </a>
          .
        </p>
      </Section>

      <Section title={t("legal.privacy.securityTitle")}>
        <p>{t("legal.privacy.securityBody")}</p>
      </Section>

      <Section title={t("legal.privacy.updatesTitle")}>
        <p>{t("legal.privacy.updatesBody")}</p>
      </Section>
    </LegalLayout>
  );
}
